<section class="empty-state" [ngClass]="{'empty-state--compact': compact}">
	<div class="iconContainer">
		<mat-icon inline>{{iconName}}</mat-icon>
	</div>
	<div class="textContainer">
		<p class="notice">{{notificationText}}</p>
		<p class="action">{{callToActionText}}</p>
	</div>
</section>
